import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      className="design-iconfont"
      width={width}
      height={height}
    >
      <path
        d="M4.5 1.5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm7 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm-7 4a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm7 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm-7 4a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm0 4a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm7-4a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm0 4a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Z"
        fillRule="evenodd"
      />
    </svg>
  )
}

const MoveIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default MoveIcon
